import React from 'react';
import * as S from './OfferBanner.styles';
import Icon from '../../../../../../stories/core-components/IconsSelector';
import useCarousel from './../../../../../containers/Common/useCarousel'
import { pushCtaOmniEvents } from '../../../../../utils/PushEvents/Omniture/clickEvents'
import { CTA_TYPE } from '../../../../../utils/PushEvents/Omniture/utils'    //'../../../../../shared/utils/PushEvents/Omniture/utils'

const onClickHelper = (item) => {
  if (item.url) {
    pushCtaOmniEvents('Offers', CTA_TYPE.HYPER_LINK, 'Dweb_home','SEO');
    window.open(item.url);
    }
}

const OfferBanner = (props) => {
  const {data} = props;
 if(data){
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
    leftCursor,
    rightCursor,
  } = useCarousel(data, 2);
  return (
    <S.HomeCaroSliderWrap  data-testid="busOfferCarouselMainImageBanner">
      <S.HomeCaroSliderInnerWrap>
        {dataList.map((item)=>{
          return (<li
          key={'offerCarousel' + item.sub_heading}
          onClick={() => onClickHelper(item)}
          >
          <S.SliderImg src={item.img_url} alt="" />
          <S.SliderInfoWrap>
       {item.sub_heading ? <S.SliderHeadInfoText>{item.sub_heading}</S.SliderHeadInfoText> :null}
        {item.validity_text   ?  <S.SliderInfoSubText>Valid till: {item.validity_text}</S.SliderInfoSubText> :null}
          </S.SliderInfoWrap>
        </li>)
        
        })}
      </S.HomeCaroSliderInnerWrap>

   {isRightCursorActive?   <S.SliderArrowRight 
   data-testid="busOfferCarouselRightArrowBtn"
   onClick={()=>{
     increment();
   }}>
        <Icon name="ArrowRight" styleProps={{fill: '#2276e3'}} />
      </S.SliderArrowRight> :null}
    {isLeftCursorActive ?  <S.SliderArrowLeft 
    data-testid="busOfferCarouselLeftArrowBtn"
    onClick={()=>{
      decrement();
    }}>
        <Icon name="ArrowRight" styleProps={{fill: '#2276e3', transform: 'rotate(-180deg)'}} />
      </S.SliderArrowLeft>:null}
    </S.HomeCaroSliderWrap>
  );
 }else{
   return null;
 }
};
export default OfferBanner;
